import { configureStore } from "@reduxjs/toolkit";
import { courier } from "./slice/onboardingSlice";
import { persistStore, persistReducer } from "redux-persist";
import storage from 'redux-persist/lib/storage';
import authReducer from "./slice/authSlice"; 
import menuReducer from "./slice/menuSlice"; 
import { combineReducers } from "@reduxjs/toolkit";
import { locationReducer } from "./slice/LocationSlice";
import { productTypeReducer } from "./slice/ProductTypeSlice";
import { productReducer } from "./slice/ProductSlice";
import { teamReducer } from "./slice/teamsSlice";

// import { composeWithDevTools } from 'redux-devtools-extension';

// const rootReducer = combineReducers({
//   Couriers: courier,
//   Locations: locationReducer,
//   ProductTypes: productTypeReducer,
//   Products: productReducer
// });

import { PURGE } from "redux-persist";

const rootReducer = (state, action) => {
  if (action.type === PURGE) {
    state = undefined; // Reset state on PURGE
  }
  return combineReducers({
    Couriers: courier,
    auth: authReducer,
    Locations: locationReducer,
    ProductTypes: productTypeReducer,
    Products: productReducer,
    menu: menuReducer,
    teams: teamReducer,
  })(state, action);
};

const persistConfig = {
  key: "root", // Key for storage (can be whatever you want)
  storage, // Storage method (localStorage in this case)
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer, // Use persistedReducer here

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Disable serializability checks
    }),
  devTools: process.env.NODE_ENV !== "production",
});
const persistor = persistStore(store);

export { store, persistor };
